import React, { useState } from 'react'
import { Button } from 'react-bootstrap'

type SorterProps = {
    onClick: (sortOrder: string) => void;
};

const Sorter = ({ onClick }: SorterProps) => {
    const [active, setActive] = useState<"asc" | "desc" | null>("asc");

    const handleClick = (order: "asc" | "desc") => {
        setActive(order);
        onClick(order);
    };

    return (
        <div className='sorter-container'>
            <Button className='sorter' onClick={() => handleClick("asc")}>
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.12215 4.99998C8.04006 5.00008 7.95877 4.98395 7.88294 4.95252C7.80711 4.92109 7.73823 4.87499 7.68027 4.81686L4.37215 1.50877L1.06403 4.8169C0.946575 4.93287 0.788011 4.99767 0.622951 4.99715C0.457891 4.99663 0.299742 4.93082 0.183029 4.81411C0.0663155 4.69739 0.000518908 4.53924 3.05612e-06 4.37418C-0.000512796 4.20912 0.0642942 4.05055 0.180276 3.93311L3.93028 0.183109C3.98829 0.125058 4.05718 0.079008 4.133 0.0475895C4.20883 0.0161711 4.2901 0 4.37217 0C4.45424 0 4.53551 0.0161711 4.61133 0.0475895C4.68716 0.079008 4.75604 0.125058 4.81406 0.183109L8.56406 3.93311C8.65145 4.02052 8.71095 4.13187 8.73505 4.2531C8.75916 4.37432 8.74678 4.49997 8.69948 4.61416C8.65218 4.72835 8.57209 4.82595 8.46933 4.89463C8.36656 4.9633 8.24575 4.99997 8.12215 4.99998Z"
                        fill={active === "asc" ? "#121212" : "#6D6D6D"}
                    />
                </svg>
            </Button>
            <Button className='sorter' onClick={() => handleClick("desc")}>
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.37093 4.99562C4.28884 4.99572 4.20755 4.97959 4.13172 4.94816C4.05588 4.91673 3.98701 4.87063 3.92905 4.8125L0.179054 1.0628C0.0636099 0.94525 -0.000739718 0.786861 6.41685e-06 0.622101C0.000752552 0.457341 0.0665339 0.299543 0.183038 0.183039C0.299542 0.0665351 0.457341 0.000752552 0.622101 6.41685e-06C0.786861 -0.000739718 0.945249 0.0636099 1.0628 0.179054L4.37093 3.48684L7.67905 0.179054C7.79661 0.0636099 7.955 -0.000739718 8.11976 6.41685e-06C8.28452 0.000752552 8.44232 0.0665351 8.55882 0.183039C8.67532 0.299543 8.74111 0.457341 8.74185 0.622101C8.7426 0.786861 8.67825 0.94525 8.5628 1.0628L4.8128 4.8125C4.75485 4.87063 4.68597 4.91673 4.61014 4.94816C4.53431 4.97959 4.45302 4.99572 4.37093 4.99562Z"
                        fill={active === "desc" ? "#121212" : "#6D6D6D"}
                    />
                </svg>
            </Button>
        </div>
    )
}

export default Sorter